import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import {
  csColorAction,
  csColorBackground,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csFocus } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const csePagination = {
  buttonBackgroundColor: css`var(--cse-pagination-button-background-color, ${csColorBackground.primary})`,
  buttonBackgroundColorDisabled: css`var(--cse-pagination-button-background-color-disabled, ${csColorBackground.primary})`,
  buttonBackgroundColorHover: css`var(--cse-pagination-button-background-color-hover, ${csColorBackground.secondary})`,
  buttonBorderRadius: css`var(--cse-pagination-button-border-radius, ${csBorder.radiusFull})`,
  buttonBoxShadowFocus: css`var(--cse-pagination-button-box-shadow-focus, ${csFocus.default})`,
  buttonColor: css`var(--cse-pagination-button-color, ${csColorText.body})`,
  buttonColorDisabled: css`var(--cse-pagination-button-color-disabled, ${csColorText.muted})`,
  buttonColorHover: css`var(--cse-pagination-button-color-hover, ${csColorAction.linkPrimary})`,
  buttonColumnGap: css`var(--cse-pagination-button-column-gap, ${csSpacing.spacing04})`,
  buttonHeight: css`var(--cse-pagination-button-height, ${csSpacing.spacing08})`,
  buttonMinWidth: css`var(--cse-pagination-button-min-width, ${csSpacing.spacing08})`,
  buttonPaddingBlock: css`var(--cse-pagination-button-padding-y, 0)`,
  buttonPaddingInline: css`var(--cse-pagination-button-padding-x, ${csSpacing.spacing05})`,
  
  buttonActiveBackgroundColor: css`var(--cse-pagination-button-active-background-color, ${csColorAction.secondary})`,
  buttonActiveBackgroundColorDisabled: css`var(--cse-pagination-button-active-background-color-disabled, ${csColorBackground.disabled})`,
  buttonActiveBackgroundColorHover: css`var(--cse-pagination-button-active-background-color-hover, ${csColorAction.secondaryHover})`,
  buttonActiveColor: css`var(--cse-pagination-button-active-color, ${csColorText.white})`,
  buttonActiveColorDisabled: css`var(--cse-pagination-button-active-color-disabled, ${csColorText.muted})`,
  buttonActiveColorHover: css`var(--cse-pagination-button-active-color-hover, ${csColorText.white})`,
}

export const buttonStyle = css`
  .cse-pagination-button {
    align-items: center;
    background-color: ${csePagination.buttonBackgroundColor};
    border: none;
    border-radius: ${csePagination.buttonBorderRadius};
    color: ${csePagination.buttonColor};
    display: flex;
    height: ${csePagination.buttonHeight};
    justify-content: center;
    min-width: ${csePagination.buttonMinWidth};
    padding-block: ${csePagination.buttonPaddingBlock};
    padding-inline: ${csePagination.buttonPaddingInline};
    text-decoration: none;
    user-select: none;
  }

  .disabled {
    pointer-events: none;
  }

  .navigation {
    column-gap: ${csePagination.buttonColumnGap};
  }

  @media (max-width: 992px) {
    .navigation > ::slotted(*) {
      display: none;
    }
  }

  .cse-pagination-button:not(.disabled, .active) {
    cursor: pointer;
  }

  .cse-pagination-button:hover {
    background-color: ${csePagination.buttonBackgroundColorHover};
    color: ${csePagination.buttonColorHover};
  }

  .cse-pagination-button:focus {
    box-shadow: ${csePagination.buttonBoxShadowFocus};
  }

  .cse-pagination-button.disabled {
    background-color: ${csePagination.buttonBackgroundColorDisabled};
    color: ${csePagination.buttonColorDisabled};
    cursor: default;
  }

  .cse-pagination-button.active {
    background-color: ${csePagination.buttonActiveBackgroundColor};
    color: ${csePagination.buttonActiveColor};
  }

  .cse-pagination-button.active:hover {
    background-color: ${csePagination.buttonActiveBackgroundColorHover};
    color: ${csePagination.buttonActiveColorHover};
  }

  .cse-pagination-button.active.disabled {
    background-color: ${csePagination.buttonActiveBackgroundColorDisabled};
    color: ${csePagination.buttonActiveColorDisabled};
  }
`
